export const products = [
  {
    id: 'agar-agar',
    name: 'Agar Agar',
    grade: 'FCC',
    category: 'Hydrocolloids & Gums',
    icon: 'ri-flask-line',
    description:
      'A natural polysaccharide derived from red algae, widely used as a gelling agent in food, pharmaceutical, and microbiological applications. Meets Food Chemicals Codex (FCC) specifications.',
    applications: ['Microbiological culture media', 'Food gelling agent', 'Pharmaceutical excipient'],
    variants: ['FCC'],
  },
  {
    id: 'adenosine-5-monophosphate',
    name: "Adenosine 5' Monophosphate",
    grade: 'House Standard',
    category: 'Nucleotides & Biochemicals',
    icon: 'ri-dna-line',
    description:
      "A nucleotide monophosphate used in biochemical research, nutritional supplements, and pharmaceutical formulations. Supplied to our in-house quality standard.",
    applications: ['Nutritional supplements', 'Biochemical research', 'Pharmaceutical APIs'],
    variants: ['House Standard'],
  },
  {
    id: 'guar-gum',
    name: 'Guar Gum',
    grade: 'USP / NF / FCC / Technical',
    category: 'Hydrocolloids & Gums',
    icon: 'ri-leaf-line',
    description:
      'A natural galactomannan polysaccharide available in multiple grades and viscosities. Used extensively as a thickener, binder, and stabilizer across pharmaceutical, food, and industrial applications.',
    applications: ['Tablet binder', 'Food thickener', 'Industrial applications'],
    variants: ['USP', 'NF', 'FCC', 'Technical Grade', 'Various viscosities'],
  },
  {
    id: 'peppermint-oil',
    name: 'Peppermint Oil',
    grade: 'USP',
    category: 'Essential Oils & Flavours',
    icon: 'ri-plant-line',
    description:
      'High-purity peppermint oil meeting United States Pharmacopeia (USP) specifications. Used as a flavouring agent, carminative, and topical analgesic in pharmaceutical and consumer health products.',
    applications: ['Oral care products', 'Topical analgesics', 'Pharmaceutical flavouring'],
    variants: ['USP'],
  },
  {
    id: 'menthol-crystals',
    name: 'Menthol Crystals',
    grade: 'USP',
    category: 'Essential Oils & Flavours',
    icon: 'ri-temp-cold-line',
    description:
      'Naturally derived menthol crystals of USP pharmaceutical grade. Widely used for their cooling sensation in topical formulations, oral care, and respiratory products.',
    applications: ['Topical formulations', 'Cough & cold products', 'Oral care'],
    variants: ['USP'],
  },
  {
    id: 'chlorocresol',
    name: 'Chlorocresol',
    grade: 'USP / EP / BP',
    category: 'Preservatives & Antimicrobials',
    icon: 'ri-shield-check-line',
    description:
      'A broad-spectrum antimicrobial preservative meeting USP, European Pharmacopoeia (EP), and British Pharmacopoeia (BP) standards. Used in injectable and topical pharmaceutical preparations.',
    applications: ['Injectable preservative', 'Topical preparations', 'Antiseptic formulations'],
    variants: ['USP', 'EP', 'BP'],
  },
  {
    id: 'calcium-sennosides',
    name: 'Calcium Sennosides',
    grade: 'USP',
    category: 'Active Pharmaceutical Ingredients',
    icon: 'ri-capsule-line',
    description:
      'A natural laxative active ingredient derived from Senna leaves, available in 20%, 60%, and 90% concentrations to USP specification. Used in OTC and prescription laxative formulations.',
    applications: ['Laxative formulations', 'OTC digestive health', 'Prescription products'],
    variants: ['20% USP', '60% USP', '90% USP'],
  },
  {
    id: 'citrated-caffeine',
    name: 'Citrated Caffeine',
    grade: 'USP',
    category: 'Active Pharmaceutical Ingredients',
    icon: 'ri-heart-pulse-line',
    description:
      'Pharmaceutical-grade citrated caffeine meeting USP specifications. Used as a CNS stimulant and in neonatal apnea treatment formulations.',
    applications: ['Neonatal apnea treatment', 'CNS stimulant formulations', 'Analgesic combinations'],
    variants: ['USP'],
  },
  {
    id: 'fischer-tropsch-wax',
    name: 'Fischer Tropsch Wax',
    grade: 'FT 110 / FT 115',
    category: 'Waxes & Lipids',
    icon: 'ri-drop-line',
    description:
      'Synthetic hard wax produced via the Fischer-Tropsch process, available in FT 110 and FT 115 grades. Used as a coating agent, release modifier, and lubricant in pharmaceutical and industrial applications.',
    applications: ['Tablet coating', 'Controlled release', 'Industrial lubricants'],
    variants: ['FT 110', 'FT 115'],
  },
  {
    id: 'iodine',
    name: 'Iodine',
    grade: 'USP',
    category: 'Inorganic Chemicals',
    icon: 'ri-test-tube-line',
    description:
      'Pharmaceutical-grade iodine meeting USP specifications. Used as an antiseptic, in thyroid medications, and as a reagent in various pharmaceutical and diagnostic applications.',
    applications: ['Antiseptic preparations', 'Thyroid medications', 'Diagnostic reagents'],
    variants: ['USP'],
  },
  {
    id: 'pectin',
    name: 'Pectin',
    grade: 'Food Grade / USP',
    category: 'Hydrocolloids & Gums',
    icon: 'ri-seedling-line',
    description:
      'A natural polysaccharide extracted from apple and citrus sources, available in multiple types and grades. Used as a gelling agent, thickener, and stabilizer in food and pharmaceutical applications.',
    applications: ['Gelling agent', 'Drug delivery matrices', 'Food stabilizer'],
    variants: ['Apple', 'Citrus', 'High Methyl', 'Low Methyl', 'Amidated', 'Food Grade', 'USP'],
  },
  {
    id: 'para-chloro-benzyl-chloride',
    name: 'Para Chloro Benzyl Chloride',
    grade: 'House Standard',
    category: 'Fine Chemicals & Intermediates',
    icon: 'ri-microscope-line',
    description:
      'A fine chemical intermediate supplied to our in-house quality standard. Used as a building block in the synthesis of pharmaceutical active ingredients and specialty chemicals.',
    applications: ['Pharmaceutical synthesis', 'Chemical intermediates', 'Specialty chemicals'],
    variants: ['House Standard'],
  },
  {
    id: 'xanthan-gum',
    name: 'Xanthan Gum',
    grade: 'USP',
    category: 'Hydrocolloids & Gums',
    icon: 'ri-bubble-chart-line',
    description:
      'A high-molecular-weight polysaccharide produced by fermentation, meeting USP specifications. Used as a viscosity modifier, suspending agent, and stabilizer in pharmaceutical and food formulations.',
    applications: ['Suspending agent', 'Viscosity modifier', 'Food stabilizer'],
    variants: ['USP'],
  },
  {
    id: 'mefenamic-acid',
    name: 'Mefenamic Acid',
    grade: 'USP / EP / BP',
    category: 'Active Pharmaceutical Ingredients',
    icon: 'ri-capsule-line',
    description:
      'A non-steroidal anti-inflammatory drug (NSAID) active pharmaceutical ingredient meeting USP, European Pharmacopoeia (EP), and British Pharmacopoeia (BP) specifications. Used primarily for the short-term treatment of mild to moderate pain and dysmenorrhoea in oral dosage forms.',
    applications: ['Oral analgesic capsules & tablets', 'Dysmenorrhoea treatment', 'Anti-inflammatory formulations'],
    variants: ['USP', 'EP', 'BP'],
  },
  {
    id: 'dichloroacetate-sodium',
    name: 'Dichloroacetate Sodium',
    grade: 'House Standard',
    category: 'Active Pharmaceutical Ingredients',
    icon: 'ri-flask-line',
    description:
      'Sodium dichloroacetate supplied to our in-house quality standard. A small molecule compound used in research and pharmaceutical applications, notably studied for its role in metabolic modulation and mitochondrial function.',
    applications: ['Pharmaceutical research', 'Metabolic disorder studies', 'Investigational drug formulations'],
    variants: ['House Standard'],
  },
  {
    id: 'diclofenac-sodium',
    name: 'Diclofenac Sodium',
    grade: 'USP / EP / BP',
    category: 'Active Pharmaceutical Ingredients',
    icon: 'ri-capsule-line',
    description:
      'A non-steroidal anti-inflammatory drug (NSAID) active pharmaceutical ingredient meeting USP, European Pharmacopoeia (EP), and British Pharmacopoeia (BP) specifications. Widely used in the treatment of pain, inflammation, and arthritis in oral, topical, and injectable dosage forms.',
    applications: ['Oral analgesic & anti-inflammatory tablets', 'Topical gels & creams', 'Injectable formulations', 'Ophthalmic preparations'],
    variants: ['USP', 'EP', 'BP'],
  },
  {
    id: 'cyanocobalamin',
    name: 'Cyanocobalamin',
    grade: 'USP / EP / BP',
    category: 'Active Pharmaceutical Ingredients',
    icon: 'ri-capsule-line',
    description:
      'Pharmaceutical-grade Cyanocobalamin (Vitamin B12) meeting USP, European Pharmacopoeia (EP), and British Pharmacopoeia (BP) specifications. An essential water-soluble vitamin used in the treatment and prevention of Vitamin B12 deficiency, pernicious anaemia, and neurological disorders. Available in multiple concentrations for oral, injectable, and nutraceutical applications.',
    applications: ['Injectable B12 formulations', 'Oral vitamin supplements', 'Nutraceutical blends', 'Pernicious anaemia treatment', 'Neurological support formulations'],
    variants: ['USP', 'EP', 'BP'],
  },
  {
    id: 'effervescent-tablet-manufacturing',
    name: 'Effervescent Tablet Manufacturing Access',
    grade: 'cGMP / Custom',
    category: 'Manufacturing & Facility Access',
    icon: 'ri-building-2-line',
    description:
      'Access to a quality-certified manufacturing facility specialising in the production of effervescent tablets of all kinds — including pharmaceutical, nutraceutical, food supplement, and veterinary formats. The facility operates under cGMP conditions with full quality management systems in place, offering flexible batch sizes, custom formulation development, and private-label production. Suitable for OTC drug products, vitamin and mineral effervescents, electrolyte blends, and specialty health supplements.',
    applications: [
      'OTC pharmaceutical effervescents',
      'Nutraceutical & vitamin tablets',
      'Electrolyte & sports nutrition',
      'Veterinary effervescent products',
      'Private-label contract manufacturing',
      'Custom formulation development',
    ],
    variants: ['cGMP Pharmaceutical', 'Nutraceutical / Food Supplement', 'Veterinary', 'Custom Formulation'],
  },
];

export const productCategories = [
  'All',
  'Hydrocolloids & Gums',
  'Active Pharmaceutical Ingredients',
  'Essential Oils & Flavours',
  'Preservatives & Antimicrobials',
  'Nucleotides & Biochemicals',
  'Waxes & Lipids',
  'Inorganic Chemicals',
  'Fine Chemicals & Intermediates',
  'Manufacturing & Facility Access',
];
